import React from "react";

import { useParams } from "react-router-dom";

import { PageContent } from "../../components";
import { useGetLaborData } from "../../hooks";
import { AddReworkRouteDialog } from "../../dialogs";

import LaborDetailsContent from "./LaborDetailsContent";
import LaborSubroutes from "./LaborSubroutes";

import { StyledContentStack } from "./styles";

export const LaborDetailsPage = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetLaborData(id);

  const childRoutes = data?.subroutes;
  return (
    <PageContent isLoading={isLoading} disablePadding>
      <StyledContentStack hasChildren={childRoutes?.length}>
        <LaborDetailsContent />
        {!!childRoutes?.length && (
          <LaborSubroutes routeId={data?.routing?.id} />
        )}
      </StyledContentStack>
      <AddReworkRouteDialog
        routeId={data?.routing?.id}
        userId={data?.user?.id}
      />
    </PageContent>
  );
};

export default LaborDetailsPage;
